import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";
import { createDebugLogger } from "@utils/debugLog";

// Import custom SCSS (non-Bootstrap)
import "./scss/style.scss";

const log = createDebugLogger("bootstrap");

log("Bootstrapping React application...");

function bootstrapApp() {
  log("Rendering React app into DOM");
  const rootElement = document.getElementById("root");

  if (!rootElement) {
    console.error("[Region] Root element not found!");
    return;
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrapApp();
